import {
	GET_MODULES_LIST,
	GET_MODULES_LIST_SUCCESS,
	GET_MODULES_LIST_FAIL,
	GET_MODULES_LIST_RESET,
} from '../actions/getModulesListAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getModulesListReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MODULES_LIST:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_MODULES_LIST_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_MODULES_LIST_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_MODULES_LIST_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getModulesListReducer;
